import { Service } from "../components/FormComponents/CustomerForm.types";

export function pushGTMEvent(
  event: string,
  service?: Service,
  extraFields?: Record<string, any>,
) {
  if (!service) return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event,
    //  service_value: service.value,
    service_label: service.label,
    service_type: service.type,
    //  service_id: service.id_action,
    ...extraFields,
  });
}
